__turbopack_context__.v({
  "card": "SkeletonLoaderCardSlim-module-scss-module__dD2RZa__card",
  "card-content": "SkeletonLoaderCardSlim-module-scss-module__dD2RZa__card-content",
  "card-content-wrapper": "SkeletonLoaderCardSlim-module-scss-module__dD2RZa__card-content-wrapper",
  "card-image": "SkeletonLoaderCardSlim-module-scss-module__dD2RZa__card-image",
  "shine": "SkeletonLoaderCardSlim-module-scss-module__dD2RZa__shine",
});
